import * as React from "react";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from "@material-ui/core/CircularProgress";
import portfolioAction from "../../../../actions/portfolio.action";
import {useEffect} from "react";
import {useState} from "react";

const ResumePaperworkButton = ({ portfolioId }) => {
  const style = {
    fontSize: 12,
    textTransform: 'none',
    minWidth: 100,
    marginLeft: 12,
  };
  const [pending, setPending] = useState(false);
  const quik = useSelector(state => state.quik);
  const dispatch = useDispatch();
  useEffect(() => {
    if (pending && quik.id) {
      const quikId = quik.id;
      window.localStorage.setItem('quikform', JSON.stringify(quik));
      const tab = window.open(`/Portal/onboard?quikId=${encodeURIComponent(quikId)}`, '_blank');
      if (!tab) {
        console.log('popup blocked')
        // window.location.href = `/Portal/onboard?quikId=${encodeURIComponent(quikId)}`;
      }
      setPending(false);
      dispatch(portfolioAction.resetQuikFormData());
    }
  }, [pending, quik.id]);

  const resumeOnboard = () => {
    setPending(true);
    dispatch(portfolioAction.getQuikFilledForms(portfolioId))
  };

  return (
    <Button
      style={style}
      onClick={resumeOnboard}
      variant="outlined"
      color='primary'
      size={'small'}
    >
      {
        pending ? <CircularProgress size={16} /> : 'Resume Paperwork'
      }
    </Button>
  );
}

export default ResumePaperworkButton;



// WEBPACK FOOTER //
// ./src/containers/HouseholdDetail/components/ResumePaperworkButton/index.jsx